// extracted by mini-css-extract-plugin
export default {"heightTransition":"---------packages-corgi-x-src-components-AnimateHeight-AnimateHeight-module__heightTransition"};